export default "__VITE_ASSET__EzkOxNXR__"